import React from 'react';
import { Col, FormGroup, Input, Label, Pagination, PaginationItem, PaginationLink, Row } from 'reactstrap';
import { usePagination, DOTS } from './usePagination';

type PaginationProps = {
  total: number;
  take: number;
  page: number;
  siblingCount?: number;
  pageOption?: any;
  onPageChange: (page: number) => void;
  onPerPageChange?: (take: number) => void | undefined;
};

const defaultPerPage = [10, 25, 50, 100];

const Paging: React.FC<PaginationProps> = ({ total, take, page, siblingCount = 1, onPageChange, onPerPageChange, pageOption = defaultPerPage }) => {
  const pageCount = Math.ceil(total / take);

  const handleClick = (e: React.MouseEvent, newPage: number) => {
    e.preventDefault();
    onPageChange(newPage);
  };

  const handleClickPerPage = (e) => {
    if (typeof (onPerPageChange) === "function") {
      onPerPageChange(e.target.value);
    }
  };

  const totalCount = total;
  const pageSize = take;
  const currentPage = page;

  const paginationRange = usePagination({
    totalCount,
    siblingCount,
    pageSize,
    currentPage
  });

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <Row>
      <Col sm={9}>
        <Pagination>
          <PaginationItem disabled={page === 1}>
            <PaginationLink previous href="#" onClick={e => handleClick(e, page - 1)} />
          </PaginationItem>
          {paginationRange.map(pageNumber => {

            if (pageNumber === DOTS) {
              return (
                <PaginationItem disabled={true}>
                  <PaginationLink><li>&#8230;</li></PaginationLink>
                </PaginationItem>
              )
            }

            return (
              <PaginationItem active={pageNumber === page} key={pageNumber}>
                <PaginationLink href="#" onClick={e => handleClick(e, pageNumber)}>
                  {pageNumber}
                </PaginationLink>
              </PaginationItem>
            );
          })}
          {/* {
            Array.from({ length: pageCount }, (_, i) => i + 1).map(p => {
              return (
                <PaginationItem active={p === page} key={p}>
                  <PaginationLink href="#" onClick={e => handleClick(e, p)}>
                    {p}
                  </PaginationLink>
                </PaginationItem>
              )
            })
          } */}
          <PaginationItem disabled={page === lastPage}>
            <PaginationLink next href="#" onClick={e => handleClick(e, page + 1)} />
          </PaginationItem>
        </Pagination>
      </Col>
      {
        (typeof (onPerPageChange) === "function")
        &&
        <Col sm={3}>
          <FormGroup row>
            <Label for="perPage" sm={6} style={{ textAlign: 'right' }}>Show</Label>
            <Col sm={6}>
              <Input value={take}
                id="perPage"
                name="perPage"
                type="select"
                onChange={handleClickPerPage}>
                {
                  (pageOption || defaultPerPage).map(it => {
                    return (<option key={it} value={it}>{it}</option>);
                  })
                }
              </Input>
            </Col>
          </FormGroup>
        </Col>
      }
    </Row>
  );
};

export default Paging;
